
import mixins from "vue-typed-mixins";
import { BModal } from "bootstrap-vue";
import CustomValidation from "@/mixins/CustomValidation";
import common from "@/mixins/Common";
import swal from "sweetalert";
import store from "@/store";
import QrcodeVue from "qrcode.vue";
import { TwoFactorTypeEnum } from "@/interfaces/TwoFactorTypeEnum";
import TwoFactorComponent from "@/components/TwoFactorComponent.vue";
import { number, object, string, boolean } from "yup";
import { mapGetters, mapMutations } from "vuex";
import { AccountSettingsViewModel } from "@/interfaces/AccountSettingsViewModel";
import { PropType } from "vue";

enum screenview {
  defaultView = 0,
  chooseAuth = 1,
  qrCode = 2,
  emailCode = 3,
  passChange = 4,
  entertoken = 5,
}
export default mixins(CustomValidation, common).extend({
  name: "account-settings",
  props: {
    val: {} as PropType<AccountSettingsViewModel | null>,
  },
  data() {
    return {
      twoFactorEnabled: false,
      authenticatorEnabled: false,
      authMethods: null as [TwoFactorTypeEnum] | null,
      authMethod: 0 as TwoFactorTypeEnum | 0,
      newAuthMethod: 0 as TwoFactorTypeEnum | 0,
      tfasecret: null,
      tfaUrl: null as string | null,
      view: screenview.defaultView,
      ctoken: null as string | null,
      pass: null as string | null,
      cpass: null as string | null,
      newpass: null as string | null,
      validated: false,
      error: "" as string | "",
      eightChars: false,
      oneNumber: false,
      lowerCase: false,
      upperCase: false,
      match: false,
      enableSubmit: false,
      enableChangePassword: true,
      submitted: false,
      requiredpasswd: null as string | null,
      schemaReset: object().shape({
        pass: string().typeError("Password is required.").required("Password is required."),
        newpass: string().typeError("Password is required.").required("Password is required."),
        cpass: string().typeError("Password is required.").required("Password is required."),
      }),
      showPasswd: false,
      isSMSOn: false as boolean,
      AffiliateSMS: false as boolean,
    };
  },
  watch: {
    newpass: function () {
      this.validatePassword();
    },
    cpass: function () {
      this.validatePassword();
    },
    val(nv: AccountSettingsViewModel) {
      this.init(nv);
    },
    showPasswd(val) {
      if (val) {
        this.$bvModal.show("modal-passwd");
        setTimeout(() => {
          this.$refs.passwdRef?.focus();
        }, 300);
      } else {
        this.$bvModal.hide("modal-passwd");
      }
    },
  },
  async mounted() {
    this.init(this.val);
    this.setupValidation(this.schemaReset);
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
    }),
    init(vm: AccountSettingsViewModel) {
      if (!this.val) return;
      this.authMethod = TwoFactorTypeEnum.None;
      this.view = screenview.defaultView;
      if (vm.identityProviderID == null) {
        this.enableChangePassword = true;
      } else {
        this.enableChangePassword = false;
      }
      this.twoFactorEnabled = vm.twoFactorEnabled;
      this.authenticatorEnabled = vm.secretEnabled;
      this.isSMSOn = vm.smsEnabled;
      this.authMethods = vm.methods;
      this.AffiliateSMS = vm.affiliateSMSEnabled;
    },
    onPasswdEnter() {
      if (this.newAuthMethod != 0) this.enableTwoFactor();
      else this.disableTwoFactor();
    },
    async enableTwoFactorApp() {
      this.newAuthMethod = TwoFactorTypeEnum.App;
      await this.enableTwoFactor();
    },
    async enableTwoFactorEmail() {
      this.newAuthMethod = TwoFactorTypeEnum.Email;
      await this.enableTwoFactor();
    },
    async enableTwoFactor() {
      if (!this.showPasswd) {
        this.requiredpasswd = "";
        this.showPasswd = true;
        return;
      }
      if (!this.requiredpasswd || this.requiredpasswd == "") {
        this.error = "Invalid password";
        return;
      }
      const settings = await store.dispatch("setupTwoFactor", { method: this.newAuthMethod, passwd: this.requiredpasswd });
      if (settings?.data) {
        this.showPasswd = false;
        this.twoFactorEnabled = settings.data.twoFactorEnabled;
        if (this.newAuthMethod == TwoFactorTypeEnum.App && settings.data.secret) {
          this.authenticatorEnabled = true;
          this.authMethod = TwoFactorTypeEnum.App;
          this.tfasecret = settings.data.secret;
          this.tfaUrl = `otpauth://totp/${settings.data.label}?secret=${settings.data.secret}&issuer=${settings.data.issuer}`;
          this.view = screenview.qrCode;
        } else {
          this.view = screenview.defaultView;
          this.authMethod = TwoFactorTypeEnum.Email;
        }
        this.newAuthMethod = 0;
        this.error = "";
      } else {
        if (settings?.errors && settings?.errors.length > 0) {
          this.error = settings.errors[0];
          //swal(settings.errors[0]);
        } else {
          this.showPasswd = false;
          swal("An error occured setting up two factor authenication.");
        }
      }
      this.requiredpasswd = null;
    },
    async disableTwoFactor() {
      if (!this.showPasswd) {
        this.requiredpasswd = "";
        this.showPasswd = true;
        return;
      }
      if (!this.requiredpasswd || this.requiredpasswd == "") {
        this.error = "Invalid password";
        return;
      }
      const settings = await store.dispatch("setupTwoFactor", { method: TwoFactorTypeEnum.None, passwd: this.requiredpasswd });
      if (settings?.data) {
        this.tfasecret = null;
        this.tfaUrl = null;
        this.authenticatorEnabled = false;
        this.twoFactorEnabled = false;
        this.authMethod = TwoFactorTypeEnum.None;
        this.view = screenview.defaultView;
        this.error = "";
        this.showPasswd = false;
      } else {
        if (settings?.errors && settings?.errors.length > 0) {
          this.error = settings.errors[0];
          //swal(settings.errors[0]);
        } else {
          this.showPasswd = false;
          swal("An error occured removing wo factor authenication.");
        }
      }
      this.requiredpasswd = null;
    },
    changePassword() {
      if (this.enableChangePassword) {
        this.view = screenview.passChange;
      }
    },
    async btnchangePassword(e: Event) {
      if (e) e.preventDefault();
      if (this.twoFactorEnabled && this.view == screenview.passChange) {
        if (this.authMethod == TwoFactorTypeEnum.None) {
          this.authMethod = this.twoFactorEnabled ? (this.authenticatorEnabled ? TwoFactorTypeEnum.App : TwoFactorTypeEnum.Email) : TwoFactorTypeEnum.None;
        } else {
          const twofactorcomp = this.$refs.twofactor;
          await twofactorcomp.init(this.authMethod, true);
        }
        this.view = screenview.entertoken;
        return;
      }
      await this.submitPasswordChange("", TwoFactorTypeEnum.None);
    },
    async submitPasswordChange(code: string, method: TwoFactorTypeEnum) {
      const resp = await store.dispatch("UserPasswordChange", { p: this.pass, np: this.newpass, c: code, m: method });
      if (!resp.data && resp.errors && resp.errors.length > 0) {
        if (!(resp.errors[0] == "Invalid two factor code")) {
          this.view = screenview.passChange;
        }
        swal(resp.errors[0]);
        return;
      }
      this.view = screenview.defaultView;
      swal("Password updated successfuly.");
      this.resetChangePass();
    },
    resetChangePass() {
      this.pass = null;
      this.cpass = null;
      this.newpass = null;
    },
    buttonClickForward() {
      if (this.enableChangePassword) {
        this.view = screenview.chooseAuth;
      }
    },
    authDone() {
      this.view = screenview.defaultView;
    },
    validatePassword: function () {
      this.enableSubmit = false;

      if (this.newpass && this.newpass.length > 7) {
        this.eightChars = true;
      } else {
        this.eightChars = false;
      }
      var rgxON = RegExp("[0-9]");
      if (this.newpass && rgxON.test(this.newpass)) {
        this.oneNumber = true;
      } else {
        this.oneNumber = false;
      }
      var lcRGX = RegExp("[a-z]");
      if (this.newpass && lcRGX.test(this.newpass)) {
        this.lowerCase = true;
      } else {
        this.lowerCase = false;
      }
      var ucRGX = RegExp("[A-Z]");
      if (this.newpass && ucRGX.test(this.newpass)) {
        this.upperCase = true;
      } else {
        this.upperCase = false;
      }
      if (this.pass && this.cpass && this.newpass == this.cpass) {
        this.match = true;
      } else {
        this.match = false;
      }

      if (this.eightChars && this.oneNumber && this.lowerCase && this.upperCase && this.match) {
        this.enableSubmit = true;
      }
    },
    async toggleSMS() {
      this.isSMSOn = !this.isSMSOn;
      const settings = await store.dispatch("UpdateAccountSettings", { smsEnabled: this.isSMSOn } as AccountSettingsViewModel);
    },
  },
  components: {
    QrcodeVue,
    TwoFactorComponent,
    BModal,
  },
});
